/* eslint array-callback-return: "off" */

import { isNil } from './index';

export function checkParam(obj: Record<string, unknown>) {
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'object' && !isNil(value)) {
      checkParam(value as Record<string, unknown>);
    }
    if (isNil(value)) {
      throw new Error(`${key} is a mandatory parameter`);
    }
  }
}
